module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA8klEQVQ4T9WUMU4CQBBF36+9AaGwsCFwCDyEJHY0EGO4g9jZ2VloMBQQEm5AxyG0sZKSzsTCjm+WgNF1lwSyDZtsszP75v/J7IrCS4V5HBHQ9iXQTbTgBXjanHeARiLnUdIknP9Ytn0DNIHb6MIFEHZYM2AQxa+BV0nre/+Aks5jBbZHm2I1SZ+/47anhwDX6jPFigPHwNu+lncpfAYWhwDrklqJ/j4Ay72Au16T7XvgoyTwDvjKAuM5lDTfKrR9BlQjxWHMVilgGwjNP01Y7AOVzEt6DyIkDf8Mdq5Ptq+AHnACDLdKcvlH9NuU+miLW/4G+1l5FbLMvs0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/twojournal.png
// module id = Tjr7
// module chunks = 18